// extracted by mini-css-extract-plugin
module.exports = {"helperText":"JoinReasonFormItem_helperText__2SlaE"};